import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import { MicroText } from './PlannerElements';
import {
  timelineTopSpacing,
  plannerItemTypeHeightMap
} from '../planner-constants';

const Wrapper = styled.div`
  padding-top: ${timelineTopSpacing}px;
  display: flex;
  align-items: center;
  height: ${({ $height }) => $height}px;
`;

const Line = styled.div`
  flex: 1 0 auto;
  margin-left: ${Spacings.SPACING_3B};
  height: 1px;
  background-color: var(--color-divider);
`;

const Timeline = ({ metaItem }) => {
  const { title, plannerItemType } = metaItem;
  return (
    <Wrapper
      $height={plannerItemTypeHeightMap[plannerItemType]}
      className="timeline"
    >
      <MicroText>{title}</MicroText>
      <Line />
    </Wrapper>
  );
};

export default Timeline;
